import { RG_TYPE } from "@project-rouge/rg-core";
import { RgDefaultCreate } from "./index19.js";
import { getApartmentCategory } from "./index110.js";
import { getEntranceDistance } from "./index249.js";
import { getEntranceDoorWidth } from "./index250.js";
import { getActionGia } from "./index251.js";
function getActions(props) {
  const units = extractUnitsFromProps(props.dataset);
  const rolloutWeights = getUnitWeights({ units, props });
  const corridorWidth = props.dataset.aggConfig.corridorWidth;
  const actions = [];
  for (let i = 0; i < units.length; i++) {
    actions.push({
      unit: units[i],
      rolloutWeight: rolloutWeights[i],
      doorPosition: getEntryPosition(units[i]),
      doorWidth: getEntranceDoorWidth(units[i]),
      gia: getActionGia(units[i], corridorWidth, props.isDoubleLoaded)
    });
  }
  return actions;
}
function getUnitWeights({ units, props }) {
  const aboveEntrance = props.dataset.apartments.aboveEntrance[0];
  const entranceWeight = props.targetEntranceCount * (aboveEntrance.size[0] / props.targetLength);
  const typicalCoreWeight = props.dataset.aggConfig.coreWithStairs.size[0] / (2 * props.dataset.aggConfig.maxTravelDistBidirectional);
  const apartmentWeightFactor = 1 - typicalCoreWeight - entranceWeight;
  const closeApartmentWeightFactor = 100 * apartmentWeightFactor;
  const weights = [];
  const permittedApartments = props.targetUnitMix.flatMap((m) => m.apartmentNames);
  for (const unit of units) {
    let weight = 0;
    if (unit.type === RG_TYPE.Core) {
      weight = unit.size[0] / (2 * props.dataset.aggConfig.maxTravelDistBidirectional);
    } else if (unit.type === RG_TYPE.Entrance) {
      weight = entranceWeight;
    } else {
      if (!permittedApartments.includes(unit.name)) {
        weight = 0;
      } else {
        const unitCategoryMix = getApartmentCategory(props.targetUnitMix, unit);
        weight = unitCategoryMix ? unitCategoryMix.ratio / unitCategoryMix.apartmentNames.length : 0;
        weight = Math.max(weight, 1e-4);
      }
      if (unit.data.closeCorridor) {
        weight *= closeApartmentWeightFactor;
      } else {
        weight *= apartmentWeightFactor;
      }
    }
    weights.push(weight);
  }
  return weights;
}
function extractUnitsFromProps(dataset) {
  const { f2fHeight, gap, moduleDepth } = dataset.aggConfig;
  const coreWithStairs = dataset.aggConfig.coreWithStairs.size;
  const coreWithLifts = dataset.aggConfig.coreWithLifts.size;
  const coreWithFfLifts = dataset.aggConfig.coreWithFfLifts.size;
  const core = RgDefaultCreate({
    type: RG_TYPE.Core,
    size: [coreWithStairs[0], f2fHeight, coreWithStairs[1]],
    anchor: [0.5, 0, 0]
  });
  const liftCore = RgDefaultCreate({
    type: RG_TYPE.Core,
    size: [coreWithLifts[0], f2fHeight, coreWithLifts[1]],
    anchor: [0.5, 0, 0],
    data: {
      jointID: "",
      muscleID: "",
      hasNonFireLift: true,
      level: -1,
      levelId: ""
    }
  });
  const fireCore = RgDefaultCreate({
    type: RG_TYPE.Core,
    size: [coreWithFfLifts[0], f2fHeight, coreWithFfLifts[1]],
    anchor: [0.5, 0, 0],
    data: {
      jointID: "",
      muscleID: "",
      hasFireLift: true,
      level: -1,
      levelId: ""
    }
  });
  const aboveEntrance = dataset.apartments.aboveEntrance[0];
  const nextToEntrance = dataset.apartments.nextToEntrance[0];
  const entranceSizeX = aboveEntrance.size[0] - nextToEntrance.size[0] - gap;
  const entrance = RgDefaultCreate({
    type: RG_TYPE.Entrance,
    size: [entranceSizeX, dataset.aggConfig.f2fHeight, moduleDepth],
    anchor: [0.5, 0, 0]
  });
  const units = [
    ...dataset.apartments.all,
    entrance,
    core,
    fireCore,
    liftCore
  ];
  return units;
}
function getEntryPosition(unit) {
  if (unit.type === RG_TYPE.Core)
    return unit.size[0] * 0.5;
  else if (unit.type === RG_TYPE.Entrance)
    return unit.size[0] * 0.5;
  else {
    return getEntranceDistance(unit);
  }
}
export {
  getActions
};
//# sourceMappingURL=index245.js.map
